import React from 'react'

import { InteractionsManager } from './InteractionsManager'

export const InteractionsContext = React.createContext<InteractionsManager | undefined>(undefined)

// FIXME this probably means if you have multiple tabs open, some data could be lost.
